const ReceivedEquipmentChart = (router, dateFrom, dateTo, locationsIds) => {
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {}
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to view by product group",
      style: {
        color: "white",
        display: ""
      }
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                router.push(
                  "/base/Tables/?location=" +
                    point.series.name +
                    "%2834%29" +
                    "&productGroup=" +
                    point.name +
                    "&type=Received&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo +
                    "&clients=" +
                    locationsIds
                );
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Locations",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const ActiveBacklogColumnChart = (
  router,
  locParam,
  city,
  locationsIds,
  changeShippedLocation
) => {
  let shippedLocation = "";
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {
        drilldown: ({ point }) => {
          changeShippedLocation(point.name);
          shippedLocation = point.name;
        },
        drillup: () => {
          changeShippedLocation("");
          shippedLocation = "";
        }
      }
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to view by product group",
      style: {
        color: "white",
        display: ""
      }
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                let shippedProductGroup = point.name;
                if (locParam == 1) {
                  router.push(
                    "/base/Tables/?location=" +
                      shippedLocation +
                      "&productGroup=" +
                      shippedProductGroup +
                      "&type=backlog" +
                      "&clients=" +
                      locationsIds
                  );
                } else {
                  router.push(
                    "/base/Tables/?location=" +
                      city +
                      "&productGroup=" +
                      shippedProductGroup +
                      "&type=backlog" +
                      "&clients=" +
                      locationsIds
                  );
                }
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Locations",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const OEMBacklogStackedChart = (router, locParam, city, locationsIds) => {
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: false
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Product Group By City"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              console.log(point.y);

              if (locParam == 1) {
                router.push(
                  "/base/Tables/?location=" +
                    point.category +
                    "%284%29" +
                    "&productGroup=" +
                    point.series.name +
                    "%284%29" +
                    "&type=OEM"
                );
              } else {
                router.push(
                  "/base/Tables/?location=" +
                    city +
                    "&type=OEM" +
                    "&clients=" +
                    locationsIds
                );
              }
            }
          }
        }
      },
      series: {
        point: {
          events: {
            click: ({ point }) => {
              console.log(point.y);
            }
          }
        }
      }
    },
    series: []
  };
};

const OEMDeliveredStackedChart = (
  router,
  dateFrom,
  dateTo,
  locParam,
  city,
  locationsIds
) => {
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: false
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Product Group By City"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              console.log(point.y);

              if (locParam == 1) {
                router.push(
                  "/base/Tables/?location=" +
                    point.category +
                    "%284%29" +
                    "&productGroup=" +
                    point.series.name +
                    "%284%29" +
                    "&type=OEMShip&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo
                );
              } else {
                router.push(
                  "/base/Tables/?location=" +
                    city +
                    "&type=ber" +
                    "&clients=" +
                    locationsIds
                );
              }
            }
          }
        }
      },
      series: {
        point: {
          events: {
            click: ({ point }) => {
              console.log(point.y);
            }
          }
        }
      }
    },
    series: []
  };
};

const BERStackedChart = (
  router,
  locParam,
  dateFrom,
  dateTo,
  city,
  locationsIds
) => {
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Product Group By City"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (locParam == 1) {
                router.push(
                  "/base/Tables/?location=" +
                    point.category +
                    "%284%29" +
                    "&productGroup=" +
                    point.series.name +
                    "%284%29" +
                    "&type=ber&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo
                );
              } else {
                router.push(
                  "/base/Tables/?location=" +
                    city +
                    "&type=ber" +
                    "&clients=" +
                    locationsIds
                );
              }
            }
          }
        }
      },
      series: {
        point: {
          events: {
            click: ({ point }) => {
              console.log(point.y);
            }
          }
        }
      }
    },
    series: []
  };
};

const TurnAroundTimeChart = () => {
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: true
    },
    title: {
      text: ""
    },
    xAxis: {
      labels: {
        style: {
          color: "white"
        }
      },
      categories: []
    },
    yAxis: {
      title: {
        text: "Days"
      }
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        stacking: "normal",
        point: {
          events: {
            click: () => {}
          }
        }
      }
    },
    series: [
      {
        name: "Turn Around Time By Products",
        data: []
      }
    ]
  };
};

const EOLStackedChart = (
  router,
  locParam,
  dateFrom,
  dateTo,
  city,
  locationsIds
) => {
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Product Group By City"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (locParam == 1) {
                router.push(
                  "/base/Tables/?location=" +
                    point.category +
                    "%284%29" +
                    "&productGroup=" +
                    point.series.name +
                    "%284%29" +
                    "&type=eol&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo
                );
              } else {
                router.push(
                  "/base/Tables/?location=" +
                    city +
                    "&type=ber" +
                    "&clients=" +
                    locationsIds
                );
              }
            }
          }
        }
      },
      series: {
        point: {
          events: {
            click: ({ point }) => {
              console.log(point.y);
            }
          }
        }
      }
    },
    series: []
  };
};

const WARStackedChart = (router, locParam, dateFrom, dateTo, locationsIds) => {
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Product Group By City"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (locParam == 1) {
                router.push(
                  "/base/Tables/?location=" +
                    point.category +
                    "%284%29" +
                    "&productGroup=" +
                    point.series.name +
                    "%284%29" +
                    "&type=war&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo +
                    "&clients=" +
                    locationsIds
                );
              } else {
                router.push("/base/Tables/?type=war&clients=" + locationsIds);
              }
            }
          }
        }
      },
      series: {
        point: {
          events: {
            click: ({ point }) => {
              console.log(point.y);
            }
          }
        }
      }
    },
    series: []
  };
};

const ActiveBacklogStackedChart = (router, changeTotalValue) => {
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Product Group By City"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        },
        events: {
          legendItemClick: () => {
            changeTotalValue();
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              router.push(
                "/base/Tables/?location=" +
                  point.category +
                  "%284%29" +
                  "&productGroup=" +
                  point.series.name +
                  "%284%29" +
                  "&type=backlog"
              );
            }
          }
        }
      },
      series: {
        point: {
          events: {
            click: ({ point }) => {
              console.log(point.y);
            }
          }
        }
      }
    },
    series: []
  };
};

const ActiveBacklogCityDashboardChart = (router, city, locationsIds) => {
  let shippedProductGroup = "";
  let shippedLocation = "";
  let productModel = "";
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {
        drilldown: ({ point }) => {
          shippedProductGroup = point.name;
        },
        drillup: () => {
          shippedProductGroup = "";
        }
      }
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to view by product group",
      style: {
        color: "white",
        display: ""
      }
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                if (this.locParam == 1) {
                  router.push(
                    "/base/Tables/?productGroup=" +
                      shippedLocation +
                      "&productGroup=" +
                      shippedProductGroup +
                      "&productModel=" +
                      point.name +
                      "&type=backlog" +
                      "&clients=" +
                      locationsIds
                  );
                } else {
                  router.push(
                    "/base/Tables/?location=" +
                      city +
                      "&productGroup=" +
                      shippedProductGroup +
                      "&productModel=" +
                      productModel +
                      "&type=backlog" +
                      "&clients=" +
                      locationsIds
                  );
                }
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Product Groups",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const BeyondEconomicalRepairCityDashboardChart = (
  router,
  locParam,
  dateFrom,
  dateTo,
  city,
  locationsIds,
  locationName
) => {
  let productGroup = "";
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {
        drilldown: ({ point }) => {
          productGroup = point.name;
        },
        drillup: () => {
          productGroup = "";
        }
      }
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to view by product group",
      style: {
        color: "white",
        display: ""
      }
    },
    exporting: {
      enabled: true
    },

    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                if (locParam == 1) {
                  router.push(
                    "/base/Tables/?location=" +
                      locationName +
                      "&productModel=" +
                      productGroup +
                      "&type=ber&date_from=" +
                      dateFrom +
                      "&date_to=" +
                      dateTo +
                      "&clients=" +
                      locationsIds
                  );
                } else {
                  router.push(
                    "/base/Tables/?location=" +
                      city +
                      "&productModel=" +
                      point.name +
                      "&productGroup=" +
                      productGroup +
                      "&type=ber&date_from=" +
                      dateFrom +
                      "&date_to=" +
                      dateTo +
                      "&clients=" +
                      locationsIds
                  );
                }
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Product Groups",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const DeliveredEquipmentColumnChart = (
  router,
  dateFrom,
  dateTo,
  locationsIds
) => {
  return {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      events: {}
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to view by product group",
      style: {
        color: "white",
        display: ""
      }
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                router.push(
                  "/base/Tables/?location=" +
                    point.series.name +
                    "%2834%29" +
                    "&productGroup=" +
                    point.name +
                    "&type=Shipped&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo +
                    "&clients=" +
                    locationsIds
                );
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Locations",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const DeliveredEquipmentStackedChart = (
  router,
  dateFrom,
  dateTo,
  changeTotalValue
) => {
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Product Group By City"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        },
        events: {
          legendItemClick: () => {
            changeTotalValue();
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              router.push(
                "/base/Tables/?location=" +
                  point.category +
                  "%284%29" +
                  "&productGroup=" +
                  point.series.name +
                  "%284%29" +
                  "&type=Shipped&date_from=" +
                  dateFrom +
                  "&date_to=" +
                  dateTo
              );
            }
          }
        }
      },
      series: {
        point: {
          events: {
            click: ({ point }) => {
              console.log(point.y);
            }
          }
        }
      }
    },
    series: []
  };
};

const DeliveredEquipmentCityDashboardChart = (
  router,
  dateFrom,
  dateTo,
  city,
  locationsIds
) => {
  let shippedProductGroup = "";
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {
        drilldown: ({ point }) => {
          shippedProductGroup = point.name;
        },
        drillup: () => {
          shippedProductGroup = "";
        }
      }
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to view by product group",
      style: {
        color: "white",
        display: ""
      }
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                router.push(
                  "/base/Tables/?location=" +
                    city +
                    "&productGroup=" +
                    shippedProductGroup +
                    "&productModel=" +
                    point.name +
                    "&type=Shipped&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo +
                    "&clients=" +
                    locationsIds
                );
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Product Groups",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const HistoricalDataLineChart = () => {
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: true
    },
    title: {
      text: ""
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total repair by Year"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: false,
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        }
      }
    },
    series: []
  };
};

const HistoricalDataStackedChart = changeTotalValue => {
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: "none"
      }
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total repair by Year"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        },
        events: {
          legendItemClick: () => {
            changeTotalValue();
          }
        }
      }
    },
    series: []
  };
};

const HistoricalDataCityDashboardChart = () => {
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: true
    },
    title: {
      text: ""
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total repair by Year"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        }
      }
    },
    series: []
  };
};

const ModelActiveBacklogChart = (router, modelData) => {
  // let shippedLocation = "";
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {
        // drilldown: ({ point }) => {
        //   shippedLocation = point.name;
        // },
        // drillup: () => {
        //   shippedLocation = "";
        // }
      }
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      //text: "Click the bars to view by product group",
      style: {
        color: "white",
        display: ""
      }
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                router.push(
                  "/base/Tables/?location=" +
                    point.name +
                    "&type=backlog" +
                    "&productModel=" +
                    modelData.model +
                    "%284%29" +
                    "&productGroup=" +
                    modelData.type +
                    "%284%29"
                );
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Locations",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const ModelBERChart = (router, dateFrom, dateTo, modelData) => {
  // let locationName = "";
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {
        // drilldown: ({ point }) => {
        //   locationName = point.name;
        // },
        // drillup: () => {
        //   locationName = "";
        // }
      }
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to view by product group",
      style: {
        color: "white",
        display: ""
      }
    },
    exporting: {
      enabled: true
    },

    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                router.push(
                  "/base/Tables/?location=" +
                    point.name +
                    "&type=ber&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo +
                    "&productModel=" +
                    modelData.model +
                    "%284%29" +
                    "&productGroup=" +
                    modelData.type +
                    "%284%29"
                );
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Locations",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const ModelDeliveredChart = (router, dateFrom, dateTo, modelData) => {
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {}
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      //text: "Click the bars to view by product group",
      style: {
        color: "white",
        display: ""
      }
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                router.push(
                  "/base/Tables/?location=" +
                    point.name +
                    "&type=Shipped&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo +
                    "&productModel=" +
                    modelData.model +
                    "%284%29" +
                    "&productGroup=" +
                    modelData.type +
                    "%284%29"
                );
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Locations",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const ModelWARChart = (router, dateFrom, dateTo, modelData) => {
  // let locationName=""
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {
        // drilldown: ({ point }) => {
        //   locationName = point.name;
        // },
        // drillup: () => {
        //   locationName = "";
        // }
      }
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to view by product group",
      style: {
        color: "white",
        display: ""
      }
    },
    exporting: {
      enabled: true
    },

    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                router.push(
                  "/base/Tables/?location=" +
                    point.name +
                    "&type=war&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo +
                    "&productModel=" +
                    modelData.model +
                    "%284%29" +
                    "&productGroup=" +
                    modelData.type +
                    "%284%29"
                );
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Locations",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const NTFStackedChart = (
  router,
  locParam,
  dateFrom,
  dateTo,
  city,
  locationsIds
) => {
  let shippedProductGroup = "";
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Product Group By City"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              console.log(point.y);

              if (locParam == 1) {
                router.push(
                  "/base/Tables/?location=" +
                    point.category +
                    "%284%29" +
                    "&productGroup=" +
                    point.series.name +
                    "%284%29" +
                    "&type=ntf&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo
                );
              } else {
                router.push(
                  "/base/Tables/?location=" +
                    city +
                    "&productGroup=" +
                    shippedProductGroup +
                    "&type=ber" +
                    "&clients=" +
                    locationsIds
                );
              }
            }
          }
        }
      },
      series: {
        point: {
          events: {
            click: ({ point }) => {
              console.log(point.y);
            }
          }
        }
      }
    },
    series: []
  };
};

const ProductModelColumnThreeChart = (router, locationsIds) => {
  let productModel = "";
  let productGroup = "";
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {
        drilldown: ({ point }) => {
          productModel = point.name;
          productGroup = point.drilldown.substring(
            0,
            point.drilldown.indexOf("-")
          );
        },
        drillup: () => {
          productModel = "";
          productGroup = "";
        }
      }
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to view by models & location",
      style: {
        color: "white",
        fontSize: "1.4em",
        fontWeight: "600",
        display: ""
      }
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span>{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                router.push(
                  "/base/Tables/?location=" +
                    point.name +
                    "&productGroup=" +
                    productGroup +
                    "%284%29" +
                    "&productModel=" +
                    productModel +
                    "&type=backlog" +
                    "&clients=" +
                    locationsIds
                );
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Product Groups",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const ProductModelDeliveredChart = (router, dateFrom, dateTo, locationsIds) => {
  let productModel = "";
  let productGroup = "";
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {
        drilldown: ({ point }) => {
          productModel = point.name;
          productGroup = point.drilldown.substring(
            0,
            point.drilldown.indexOf("-")
          );
        },
        drillup: () => {
          productModel = "";
          productGroup = "";
        }
      }
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to view by models & location",
      style: {
        color: "white",
        fontSize: "1.4em",
        fontWeight: "600",
        display: ""
      }
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span>{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                router.push(
                  "/base/Tables/?location=" +
                    point.name +
                    "&productGroup=" +
                    productGroup +
                    "%284%29" +
                    "&productModel=" +
                    productModel +
                    "&type=Shipped&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo +
                    "&clients=" +
                    locationsIds
                );
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Product Groups",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const RegionalAnalyticsActiveBacklogChart = (
  router,
  dateFrom,
  dateTo,
  locationsIds
) => {
  let locationName = "";
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {
        drilldown: ({ point }) => {
          locationName = point.name;
        },
        drillup: () => {
          locationName = "";
        }
      }
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to view by product group",
      style: {
        color: "white",
        display: ""
      }
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span>{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                router.push(
                  "/base/Tables/?location=" +
                    locationName +
                    "&productGroup=" +
                    point.name +
                    "&type=SubDivisionBacklog&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo +
                    "&clients=" +
                    locationsIds
                );
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Regionals",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const RegionalAnalyticsDeliveredEquipmentChart = (
  router,
  dateFrom,
  dateTo,
  locationsIds
) => {
  let locationName = "";
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {
        drilldown: ({ point }) => {
          locationName = point.name;
        },
        drillup: () => {
          locationName = "";
        }
      }
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to view by product group",
      style: {
        color: "white",
        display: ""
      }
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span>{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                router.push(
                  "/base/Tables/?location=" +
                    locationName +
                    "&productGroup=" +
                    point.name +
                    "&type=SubDivisionDelivered&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo +
                    "&clients=" +
                    locationsIds
                );
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Regionals",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const RepairAnalyticsLineChart = total => {
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: true
    },
    title: {
      text: ""
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total repair by Month"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: false,
        formatter: function() {
          return "Total: " + total;
        },
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        }
      }
    },
    series: []
  };
};

const RepairAnalyticsStackedChart = (total, changeTotalValue) => {
  return {
    tooltip: {
      formatter: function() {
        return;
      }
    },
    chart: {
      type: "column",
      backgroundColor: "transparent"
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    legend: {
      itemStyle: {
        color: "white"
      }
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total repair by Month"
      },
      labels: {
        style: {
          color: "white"
        }
      },
      stackLabels: {
        enabled: true,
        formatter: function() {
          return "Total: " + total;
        },
        style: {
          fontWeight: "bold",
          color: "white"
        }
      }
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function() {
            return "TEST";
          }
        },
        events: {
          legendItemClick: () => {
            changeTotalValue();
          }
        }
      }
    },
    series: []
  };
};

const SubDivisionFinancialChartChart = (router, dateFrom, dateTo) => {
  // let locationName ="";
  return {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      events: {
        // drilldown: ({ point }) => {
        //   locationName = point.name;
        // },
        // drillup: () => {
        //   locationName = "";
        // }
      }
    },
    exporting: {
      enabled: true
    },
    title: {
      text: "",
      style: {
        color: "white",
        display: ""
      }
    },
    subtitle: {
      text: "Click the bars to see details",
      style: {
        color: "white",
        display: ""
      }
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "white"
        }
      }
    },
    yAxis: {
      title: {
        text: "Percentage Of Total"
      }
    },
    legend: {
      enabled: false
    },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        "<span>{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.y:.1f}%",
          color: "white",
          style: {
            textOutline: false
          }
        },
        point: {
          events: {
            click: ({ point }) => {
              if (point.name) {
                router.push(
                  "/base/Tables/?location=" +
                    point.name1 +
                    "&type=financial-subdivision&date_from=" +
                    dateFrom +
                    "&date_to=" +
                    dateTo
                );
              }
            }
          }
        }
      }
    },
    drilldown: {
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "white"
      },
      activeDataLabelStyle: {
        color: "white"
      }
    },
    series: [
      {
        name: "Regionals",
        colorByPoint: true,
        data: null
      }
    ]
  };
};

const MapByStateChart = () => {
  return {
    showZoomOut: true,
    tooltip: { isHtml: true },
    backgroundColor: "#3a4149",
    legend: {
      textStyle: { color: "black", fontSize: 16, font: "Segoe UI" }
    },
    region: "USA",
    sizeAxis: {
      minSize: 8, //code to set min and max marker size
      maxSize: 8
    },
    resolution: "provinces",
    magnifyingGlass: { enable: true, zoomFactor: 1.5 },
    displayMode: "markers",
    enableRegionInteractivity: true,
    keepAspectRatio: false,

    colorAxis: { colors: ["#28B463", "#6C3483"] }
  };
};

export {
  ReceivedEquipmentChart,
  ActiveBacklogColumnChart,
  OEMBacklogStackedChart,
  OEMDeliveredStackedChart,
  BERStackedChart,
  TurnAroundTimeChart,
  EOLStackedChart,
  WARStackedChart,
  ActiveBacklogStackedChart,
  ActiveBacklogCityDashboardChart,
  BeyondEconomicalRepairCityDashboardChart,
  DeliveredEquipmentColumnChart,
  DeliveredEquipmentStackedChart,
  DeliveredEquipmentCityDashboardChart,
  HistoricalDataLineChart,
  HistoricalDataStackedChart,
  HistoricalDataCityDashboardChart,
  ModelActiveBacklogChart,
  ModelBERChart,
  ModelDeliveredChart,
  ModelWARChart,
  NTFStackedChart,
  ProductModelColumnThreeChart,
  ProductModelDeliveredChart,
  RegionalAnalyticsActiveBacklogChart,
  RegionalAnalyticsDeliveredEquipmentChart,
  RepairAnalyticsLineChart,
  RepairAnalyticsStackedChart,
  SubDivisionFinancialChartChart,
  MapByStateChart
};
